import { Injectable } from '@angular/core';
import { AppInsights } from 'applicationinsights-js';
import { SnEnvService } from '@insight/serenity-env';

@Injectable()
export class AppInsightsService {

  private config: Microsoft.ApplicationInsights.IConfig = {
    instrumentationKey: this._envService.get('appInsights').instrumentationKey,
    enableCorsCorrelation: true,
    samplingPercentage: 100
  };

  constructor(private _envService: SnEnvService) {
    if (!AppInsights.config) {
      AppInsights.downloadAndSetup(this.config);
    }
  }

  get context(): Microsoft.ApplicationInsights.ITelemetryContext {
    return AppInsights.context;
  }

  logPageView(name?: string, url?: string, properties?: any, measurements?: any, duration?: number) {
    AppInsights.trackPageView(name, url, properties, measurements, duration);
  }

  logEvent(name: string, properties?: any, measurements?: any) {
    AppInsights.trackEvent(name, properties, measurements);
  }

}
